import { IPagination, Platform } from "./common";
import type { ScoreMode } from "../bridge/contract";

export interface IDailyLeaderboardEntry {
    dailyEntryId: string;
    gameId: string;
    identityId: string | null;
    entryDate: string;
    score: number;
    rank?: number;
    displayName?: string;
    avatarUrl?: string;
    metadata?: Record<string, any>;
    platform?: Platform;
    createdAt: string;
    updatedAt: string;
}

export enum LeaderboardScope {
    TOP = 'top',
    NEARBY = 'nearby',
    ALL = 'all',
}

export interface IQueryLeaderboardRequest extends IPagination {
    scope?: LeaderboardScope;
    identityId?: string;
    userId?: string;
    anonymousId?: string;
    eightpointId?: string;
    range?: number;
}

export interface IScoreGrant {
    type: string;
    finalXp: number;
}

export type { ScoreMode };

export interface ISubmitScoreRequest {
    roundId: string;
    score: number;
    durationMs?: number;
    challengeCode?: string;
    scoreMode?: ScoreMode;
}

export type IOverwriteScoreRequest = Omit<ISubmitScoreRequest, 'scoreMode'>;

export interface IOverwriteScoreResponse {
    rank: number;
    score: number;
    variant: 'cracked_top' | 'on_board' | 'below_board';
    earnedXpThisRound: number;
    grantsApplied: IScoreGrant[];
    nudge: any | null;
}

export type ISubmitScoreResponse = IOverwriteScoreResponse;

export interface ILeaderboardEntry {
    leaderboardEntryId: string;
    gameId: string;
    identityId: string | null;
    currentScore: number;
    totalScore: number;
    bestDailyScore?: number;
    currentRank?: number;
    totalRank?: number;
    displayName?: string;
    avatarUrl?: string;
    totalDaysPlayed: number;
    currentStreak: number;
    bestStreak: number;
    lastPlayDate?: string;
    metadata?: Record<string, any>;
    platform?: Platform;
    createdAt: string;
    updatedAt: string;
}


